import { render, staticRenderFns } from "./CategoriesDataTable.vue?vue&type=template&id=6abf8062&"
import script from "./CategoriesDataTable.vue?vue&type=script&setup=true&lang=ts&"
export * from "./CategoriesDataTable.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports